interface Props {
  row: { _original: Record<string, string> & { id: string } };
  isExpanded: string | null;
  setIsExpanded: (value: string | null) => void;
  value?: string;
  valueAccessor?: string;
}

const ExpanderCell = ({ row, isExpanded, setIsExpanded, value, valueAccessor = "id" }: Props) => {
  if (!value) {
    value = valueAccessor ? row._original[valueAccessor] : row._original.id;
  }

  return (
    <div
      style={{
        cursor: "pointer",
        fontSize: "4rem",
        lineHeight: "20px",
      }}
    >
      {isExpanded === value ?
        <span onClick={() => setIsExpanded(null)}>
          <i className="pe-7s-angle-down" />
        </span>
      : <span onClick={() => setIsExpanded(value ?? null)}>
          <i className="pe-7s-angle-right" />
        </span>
      }
    </div>
  );
};

export default ExpanderCell;
